import { render, staticRenderFns } from "./ZoneItemsHeader.vue?vue&type=template&id=542279fe&"
import script from "./ZoneItemsHeader.vue?vue&type=script&lang=ts&"
export * from "./ZoneItemsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ZoneItemsHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports